import { STRIPE_COUNTRY } from 'constants/sales'
import { getCartLabels } from 'utils/cart'

export default (cart, dict, cartDict, sales) => ({
  // Stripe account - country code
  country: STRIPE_COUNTRY,
  displayItems: getCartLabels(
    cart,
    dict,
    cartDict,
    sales,
    num => Math.round(num) * 100,
  ),
  currency: sales.currency.toLowerCase(),
  total: {
    label: cartDict.total.title,
    amount: Math.round(cart.sum.cost * 100),
  },
})
